import React from 'react';
import { ResourceId } from 'framework/crud';

type CustomHtmlTagHelperDependencies = {
  getEmployeeUrl: (id: ResourceId) => string;
  getCandidateUrl: (id: ResourceId) => string;
  getLeadUrl: (id: ResourceId) => string;
  getOpportunityUrl: (id: ResourceId) => string;
  getAccountUrl: (id: ResourceId) => string;
  getContactUrl: (id: ResourceId) => string;
  getEmployeeOfferUrl: (id: ResourceId) => string;
  getCandidateOfferUrl: (id: ResourceId) => string;
  getProjectUrl: (id: ResourceId) => string;
  getCompanyServiceUrl: (id: ResourceId) => string;
  searchSensitiveRecruitingInfo: (ids: string[]) => Promise<Array<{ value?: StringOrNumber }>>;
  formatDateWithTimezone: (value: string, format: string) => Nullable<string>;
  getUserTimezone: () => string;
  getEmployeeNameDataById: (
    id?: string,
    isHandleError?: boolean,
  ) => Promise<{
    nameEn: {
      firstName: string;
      lastName: string;
    };
  }>;
};

const CustomHtmlTagHelperDependenciesContext = React.createContext<Nullable<CustomHtmlTagHelperDependencies>>(null);

export const CustomHtmlTagHelperDependenciesProvider = ({
  children,
  value,
}: {
  children: React.ReactNode;
  value: CustomHtmlTagHelperDependencies;
}) =>
  React.createElement(CustomHtmlTagHelperDependenciesContext.Provider, {
    value,
    children,
  });

export const useCustomHtmlTagHelperDependencies = (): CustomHtmlTagHelperDependencies => {
  const configuredDependencies = React.useContext(CustomHtmlTagHelperDependenciesContext);

  if (!configuredDependencies) {
    throw new Error('Custom HTML tag helper dependencies are missing');
  }

  return configuredDependencies;
};
